import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import { Grid, InputLabel } from "@material-ui/core";
import DatePicker from "react-datepicker";
import OutlinedTextField from '../../OutlinedTextField';

import translate from "../../../locales";
import moment from "moment";
import { jsonDateFormat, stringToDate, toDateObject } from "../../../_helpers/dateConvert";
import SwitchRateTableDialog from "../../Dialogs/SwitchRateTableDialog";

const __t = translate;

const RateMappingForm = forwardRef((props, ref) => {
    const [fromDate, setFromDate] = useState(props.rateMapping ? stringToDate(props.rateMapping.fromDate, jsonDateFormat) : "");
    const [fromDateError, setFromDateError] = useState(null);
    const [toDate, setToDate] = useState(props.rateMapping ? stringToDate(props.rateMapping.toDate, jsonDateFormat) : "");
    const [toDateError, setToDateError] = useState(null);
    const [rates, setRates] = useState(props.rateMapping ? props.rateMapping.rates : []);
    const [ratesError, setRatesError] = useState(null);

    const [rateModal, setRateModal] = useState(false);

    useImperativeHandle(ref, () => ({
        getData: () => {
            let hasError = false;

            setFromDateError(null);
            setToDateError(null);

            if (!fromDate) {
                setFromDateError(__t('from_date_required'));
                hasError = true;
            }

            if (!toDate) {
                setToDateError(__t('to_date_required'));
                hasError = true;
            }

            if (hasError)
                return false;

            return {
                fromDate: fromDate,
                toDate: toDate,
                rates: rates
            };
        }
    }))

    return (
        <>
            <SwitchRateTableDialog
                open={rateModal}
                allRates={props.allRates}
                rates={rates}
                onCancel={() => setRateModal(false)}
                onSubmit={(selectedRates) => {
                    setRates(selectedRates);
                    setRateModal(false);
                }}
            />
            <Grid container spacing={8} direction="row" justify="flex-start" alignItems="center">
                <Grid item xs={3}>
                    <InputLabel shrink required>{__t('valid_from')} ({__t('inclusive')}):</InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <DatePicker
                        locale={props.locale}
                        selected={fromDate}
                        dateFormat="dd/MM/yyyy"
                        todayButton={__t("today_label")}
                        disabledKeyboardNavigation
                        onChange={(date) => {
                            setFromDate(date);
                        }}
                        customInput={
                            <OutlinedTextField
                                readOnly={true}
                                hideLabel={true}
                                error={fromDateError}
                            />
                        }
                        maxDate={toDate && moment(toDate).isValid ? moment(toDate).add(-1, 'days').toDate() : toDateObject('31/12/2999')}
                        readOnly={props.readonly}
                    />
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={3}>
                    <InputLabel shrink required>{__t('valid_to')} ({__t('exclusive')}):</InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <DatePicker
                        locale={props.locale}
                        selected={toDate}
                        dateFormat="dd/MM/yyyy"
                        todayButton={__t("today_label")}
                        disabledKeyboardNavigation
                        onChange={(date) => {
                            setToDate(date);
                        }}
                        customInput={
                            <OutlinedTextField
                                readOnly={true}
                                hideLabel={true}
                                error={toDateError}
                            />
                        }
                        minDate={moment(fromDate).isValid ? moment(fromDate).add(1, 'days').toDate() : moment(new Date()).add(1, 'days').toDate()}
                        maxDate={toDateObject('01/01/3000')}
                        readOnly={props.readonly}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputLabel shrink >{__t('rates')}:</InputLabel>
                </Grid>
                <Grid item xs={10}>
                    <OutlinedTextField
                        value={rates.map(r => r.name).join(', ')}
                        inputProps={{ style: { textTransform: 'uppercase' }, readOnly: true }}
                        onClick={() => {
                            setRateModal(true);
                        }}
                        disabled={props.readonly}
                    />
                </Grid>
            </Grid>
        </>
    )
});

RateMappingForm.propTypes = {
    allRates: PropTypes.array,
    rateMapping: PropTypes.object,
    locale: PropTypes.string,
    readonly: PropTypes.bool,
}

export default RateMappingForm;